import {
    Header,
    Divider,
    List,

} from "semantic-ui-react";
import { Select } from "antd";

const { Option } = Select;

const TabProfileJury =({datos, userState, handleClickTab, setStatus, status}: any)=> {

    const handleStatusChange = (value: any) => {
        setStatus(value)
    }

        return (
            <>
                {datos.hasOwnProperty('perfil') ? (
                    <>
                        <Header size="small" as="h2">
                            Descripción del jurado
                        </Header>
                        <p className="font-size-12px font-family-Work-Sans">
                            {datos.perfil}
                        </p>
                        <Divider />
                    </>
                ) : null}
                
             {/*    {datos && datos.experiencias ? (
                    <>
                        <Header size="small" as="h2">
                            Ha sido jurado en
                        </Header>
                        <Divider />
                        
                        <List bulleted as="ul">
                        {datos.experiencias.map((experiencias: any, index: number) => {
                            return (
                                
                                experiencias && (
                                    <List.Item
                                        key={index}
                                        as="li"
                                        className="font-size-12px font-family-Work-Sans"
                                    >
                                        {experiencias.area}
                                    </List.Item>
                                ))
                        })}
                          
                        </List>
                
                    </>
                ) : null} */}
                
                
   {/*              {datos !== undefined && Object.keys(datos.categories).length !== 0 && (
                    <List bulleted as="ul">
                        {datos.categories.map((category: any, index: number) => {
                            return (
                                
                                category !== null && (
                                    <List.Item
                                        key={index}
                                        as="li"
                                        className="font-size-12px font-family-Work-Sans"
                                    >
                                        {category}
                                    </List.Item>
                                )
                            );
                        })}
                    </List>
                )} */}
                        {datos && datos.areas_conocimientos  ? (
                    <>
                        <Header size="small" as="h2">
                            Area principal de conocimiento
                        </Header>
                         {datos.areas_conocimientos.map((areas_conocimientos: any, index: number) => {
                            return (
                                
                                areas_conocimientos && (
                                    <p className="font-size-12px font-family-Work-Sans">
                                    {areas_conocimientos.area_principal}
                                </p>
                                ))
                        })}
                        
                        <Divider />
                    </>
                ) : null}
            
                        {datos && datos.areas_conocimientos  ? (
                    <>
                        <Header size="small" as="h2">
                        Categorias de conocimiento
                        </Header>
                         {datos.areas_conocimientos.map((datos: any, index: number) => {

                             return datos.areas_conocimientos.map((newData: any, index: number) => {
                                
                                return newData ? (
                                    <List.Item
                                    key={index}
                                    as="li"
                                    className="font-size-12px font-family-Work-Sans"
                                >
                                    {newData.nombre}
                                </List.Item> 
                                ) : null 
                             })
                           /*  return  datos.areas_conocimientos.map((datosAreas: any, index: number)=>{ */        
/*                              return datosAreas ? (
                                <List.Item
                                    key={index}
                                    as="li"
                                    className="font-size-12px font-family-Work-Sans"
                                >
                                    {datosAreas.areas_conocimientos.nombre}
                                </List.Item> ) : null  */   
                               /*  } ) */
                        })}
                        
                        <Divider />
                    </>
                ) : ''}

                {userState && handleClickTab && (
                    <>
                        <Header size="small" as="h2">
                            Respuesta del jurado
                        </Header>
                        <Divider />
                        <Select defaultValue={datos.status} onChange={(e) => handleStatusChange(e)} style={{ width: "200px" }}>
                            <Option value="Aceptó">Aceptó</Option>
                            <Option value="No aceptó">No aceptó</Option>
                            <Option value="No responde">No responde</Option>  
                        </Select>
                    </>
                )}
            </>
        );
    };



export default TabProfileJury
